/**
 * Lightweight event bus for rate-limit signals between fetchAuth and React UI.
 *
 * Two event types:
 *  - "global_block"   → device hit the 60 req/min global cap  → full-screen block
 *  - "route_block"    → endpoint spam (10 req/2 min)          → popup toast
 */

const listeners = {
  global_block: new Set(),
  route_block: new Set(),
};

export function onRateLimit(event, fn) {
  listeners[event].add(fn);
  return () => listeners[event].delete(fn);
}

export function emitRateLimit(event, retryAfter) {
  listeners[event].forEach((fn) => fn(retryAfter));
}
